import React, { useState, useEffect } from "react";
import contactImage1 from "../../assets/images/users/user-1.jpg";
import contactImage2 from "../../assets/images/users/user-2.jpg";
import contactImage3 from "../../assets/images/users/user-3.jpg";
import contactImage4 from "../../assets/images/users/user-4.jpg";
import logo from "../../assets/images/asset-planet-background.png";
import tag from "../../assets/images/chats/tag.png";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import penIcon from "../../assets/images/DeathModuleNew/penWhite.svg";
import setting from "../../assets/SVGs/setting.svg";
import { setActiveStep } from "../../redux/slices/loginSlice";
import { useDispatch } from "react-redux";
// import { ConnectAccount } from "./ConnectAccount";
import Loader from "../../components/styled-components/loader/loader";
import "./contacts.css";
import { ViewClientContacts } from "./ViewClientContacts";
import { UpdateClinetContacts } from "./UpdateClinetContacts";
import axios from "axios";
import DEATH_API from "../../apis/death.api";
import ConnectAccount from "./ConnectAccount";
import { Table,Modal } from "antd";
import { Menu, Dropdown, Icon } from 'antd';
import swal from "sweetalert";
import { AddContacts } from "./AddContacts";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useHistory, useLocation } from "react-router-dom";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
import ModalVideo from "../ModuleVideos/ModalVideo";

export const ClientPlan = () => {
  const [dropdown, setDropdown] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [contactdropdown, setContactDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [loading, setLoading] = useState(false);
  const [importContacts, setImportContacts] = useState(false);
  const [viewContacts, setViewContacts] = useState(false);
  const [editContacts, setEditContacts] = useState(false);
  const [clientContacts, setClientContacts] = useState([]);
  const [manageContact, setManageContact] = useState(null);
  const [addContact,setAddContact]= useState(false);
  const [addEmailTemplate, setAddEmailTemplate] = useState(false);
  const [emailTemplateData, setEmailTemplateData] = useState({});
  const [addTextTemplate, setAddTextTemplate] = useState(false);
  const [textTemplateData, setTextTemplateData] = useState({});
  const [searchGroupContacts, setSearchGroupContacts] = useState(""); 
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const closeEmailTemplateModal = () => {
    setAddEmailTemplate(false);
  };
  const saveEmailTemplateModal = async () => {
    setAddEmailTemplate(false);

   console.log("emailtemlte data",emailTemplateData)
   let payload={
    ...emailTemplateData,
    type:"email",
  }
  try {
    setLoading(true);
    let apiResponse = await DEATH_API.sendEmailsToGroup(selectedGroupIndex,payload);
    console.log("apiResponse", apiResponse);
    if (apiResponse && apiResponse.status===200) {
     swal("Success", apiResponse.message, "success");
    }
    setLoading(false);
  } catch (error) {
    console.log(error);
    setLoading(false);
  }

   setEmailTemplateData({});
  };

  const closeTextTemplateModal = () => {
    setAddTextTemplate(false);
  };
  const saveTextTemplateModal = async () => {
    setAddTextTemplate(false);
    console.log("textTemplateData",textTemplateData,selectedGroupIndex);
    let payload={
      ...textTemplateData,
      type:"text",
    }
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.sendEmailsToGroup(selectedGroupIndex,payload);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
        swal("Success", apiResponse.message, "success");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  
    setTextTemplateData({});
  };
  // checkboxes
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
    // setSelectedCheckContacts([]);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };

  const [selectedCheckContacts, setSelectedCheckContacts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const handleCheckboxChange = (contactId) => {
    if (selectedCheckContacts.includes(contactId)) {
      setSelectedCheckContacts(selectedCheckContacts.filter((id) => id !== contactId));
    } else {
      setSelectedCheckContacts([...selectedCheckContacts, contactId]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCheckContacts([]);
    } else {
      setSelectedCheckContacts(filteredContacts.map((contact) => contact.id));
    }
    setSelectAll(!selectAll);
  };


  // add groups
  const [groupName, setGroupName] = useState('');
  const [groupNameEdit, setGroupNameEdit] = useState('');
  const [allGroups, setAllGroups] = useState([]);

  const [addGroup, setAddGroup] = useState(false);
  const [groupDropdown, setGroupDropdown] = useState(false);
  const [selectedGroupIndex, setSelectedGroupIndex] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [editGroup, setEditGroup] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  // const handleCheckboxChange = (contactId) => {
  //   // Check if the contact is already selected
  //   const index = selectedContacts.indexOf(contactId);
  //   if (index === -1) {
  //     // If not selected, add it to the array
  //     setSelectedContacts([...selectedContacts, contactId]);
  //   } else {
  //     // If already selected, remove it from the array
  //     const updatedContacts = [...selectedContacts];
  //     updatedContacts.splice(index, 1);
  //     setSelectedContacts(updatedContacts);
  //   }
  // };
  const convertToCSV = () => {
    // Filter out keys to exclude from export
    const excludedKeys = ["deleted", "clientId","enable","cloud_contact_details","id"];
    
    // Get the headers excluding excluded keys
    const headers = Object.keys(clientContacts[0])
      .filter(key => !excludedKeys.includes(key))
      .join(',');
  
    // Convert data to CSV, excluding excluded keys
    const csvData = clientContacts.map(item =>
      Object.keys(item)
        .filter(key => !excludedKeys.includes(key))
        .map(key => item[key])
        .join(',')
    ).join('\n');
  
    return `${headers}\n${csvData}`;
  };

  const downloadCSV = () => {
    const csvData = convertToCSV();
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'cloudContacts.csv');
    document.body.appendChild(link);
    link.click();
  };
  const convertSelectedToCSV = () => {
    // Filter out keys to exclude from export
    const excludedKeys = ["deleted", "clientId", "enable","cloud_contact_details","id"];
    
    // Get the headers excluding excluded keys
    const headers = Object.keys(clientContacts[0])
      .filter(key => !excludedKeys.includes(key))
      .join(',');
  
    // Filter clientContacts to include only selected contacts
    const selectedContacts = clientContacts.filter(item => selectedCheckContacts.includes(item.id));
  
    // Convert selected contacts to CSV, excluding excluded keys
    const csvData = selectedContacts.map(item =>
      Object.keys(item)
        .filter(key => !excludedKeys.includes(key))
        .map(key => item[key])
        .join(',')
    ).join('\n');
  
    return `${headers}\n${csvData}`;
  };
  
  const downloadSelectedCSV = () => {
    const csvData = convertSelectedToCSV();
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'selectedContacts.csv');
    document.body.appendChild(link);
    link.click();
    setSelectAll(false);
    setSelectedCheckContacts([]);
  };
  
  const deleteSelectCloudContact = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete these Contacts?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.DeleteSelectedContacts(selectedCheckContacts);
          setLoading(false);
          await getContacts();
          await getGroups();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Contacts has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Contacts are safe :)", "error");
      }
    });
    setSelectAll(false);
    setSelectedCheckContacts([]);
  };

  // const sortBy = (key) => {
  //   // Create a copy of the contacts array to avoid mutating the state directly
  //   const sortedContacts = [...clientContacts];

  //   // Sort the contacts array based on the provided key
  //   sortedContacts.sort((a, b) => {
  //     // Handle sorting by name
  //     if (key === 'name') {
  //       // Add null checks for name properties
  //       if (a.name && b.name) {
  //         return a.name.localeCompare(b.name);
  //       }
  //       // If either name is null, prioritize sorting by other criteria
  //       return 0;
  //     }
  //     // Handle sorting by phone number
  //     if (key === 'phoneNumber') {
  //     // Add null check for phoneNumber property
  //     if (a.phoneNumber && b.phoneNumber) {
  //       return a.phoneNumber.localeCompare(b.phoneNumber);
  //     }
  //     // If either phoneNumber is null, prioritize sorting by other criteria
  //     return 0;
  //       // return a.phoneNumber.localeCompare(b.phoneNumber);
  //     }
  //   });

  //   // Update the state with the sorted contacts array
  //   setClientContacts(sortedContacts);
  // };
  const sortBy = (key) => {
    // Create a copy of the contacts array to avoid mutating the state directly
    const sortedContacts = [...clientContacts];
  
    sortedContacts.sort((a, b) => {
      // Handle sorting by firstName
      if (key === 'firstName') {
        console.log("firstname")
        if (a.firstName && b.firstName) {
          return a.firstName.localeCompare(b.firstName);
        }
        return 0;
      }
  
      // Handle sorting by lastName
      if (key === 'lastName') {
        console.log("lastName")
        if (a.lastName && b.lastName) {
          return a.lastName.localeCompare(b.lastName);
        }
        return 0;
      }
        return 0;
    });
  
    // Update the state with the sorted contacts array
    console.log("sortedContacts",sortedContacts)
    setClientContacts(sortedContacts);
  };
  


  const exportCloudContacts= async()=>{
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.exportCloudContacts();
      console.log("apiResponse", apiResponse);
      // if (apiResponse && apiResponse.status===200) {
      //  await getGroupContacts(selectedGroupIndex);
      // }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }
  const addContactsToGroup= async()=>{
    console.log("Group Name:", selectedGroupIndex);
    const selectedIds = selectedRows.map(row => row.id);
    console.log(selectedIds);
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.createGroupContacts({groupId:selectedGroupIndex ,contactIds:selectedIds});
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
       await getGroupContacts(selectedGroupIndex);
       await getContacts();
       await getGroups();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    // setGroupName('');
    setSelectedRows([]);
    // setEditGroup(false);
  }
  const createGroup= async()=>{
    console.log("Group Name:", groupName);
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.createGroup(groupName);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
       await getGroups();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    setGroupName('');
  }

  const updateGroupName=async()=>{
    console.log("Group Name:", groupName,selectedGroupIndex);
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.updateGroup(selectedGroupIndex,groupName);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status===200) {
       await getGroups();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }
  const groupCols = [
    {
      title: 'Group Name',
      dataIndex: 'name',
    },
    {
      title: 'Group Members',
      dataIndex: 'count',
    },
    {
      title: 'Action',
      render: (record, index) => {
        return (
          <React.Fragment>
              <div style={{ display: "flex" }} key={index}>
                {" "}
                <img
                  style={{ cursor: "pointer", marginRight: "1rem" }}
                  src={menuIcon}
                  alt="menuIcon"
                  height={15}
                  width={4}
                  onClick={() => {
                    console.log("recode", record);
                    // getSelectedRow(record.id);
                    setSelectedGroupIndex(record.id);
                    setGroupName(record.name);
                    setGroupDropdown(!groupDropdown);
                  }}
                ></img>{" "}
                {groupDropdown && selectedGroupIndex === record.id && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setGroupDropdown(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}
                    ></div>

                    <div className="dropdown" style={{ zIndex: "9999" }}>
                      <ul className="dropdownul">
                        <li
                          className="liHover"
                          onClick={() => {
                            setGroupDropdown(false);
                            setEditGroup(true);
                            setAddGroup(false);
                            getGroupContacts(record.id)
                          }}
                        >
                          Edit
                        </li>

                        <li
                          className="liHover"
                          onClick={() => {
                            deleteGroup(record.id)
                            setGroupDropdown(false);
                          }}
                        >
                          Delete
                        </li>
                      </ul>
                    </div>
                  </React.Fragment>
                )}{" "}
              
              </div>
              
          </React.Fragment>
        );
      },
    },
  ];
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: (a, b) =>
        a.name > b.name ? 1 : a.name === b.name ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: 'Phone',
      dataIndex: 'phoneNumber',
      sorter: (a, b) =>
        a.phoneNumber > b.phoneNumber ? 1 : a.phoneNumber === b.phoneNumber ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      sorter: (a, b) =>
        a.email > b.email ? 1 : a.email === b.email ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: 'Group',
      // dataIndex: 'groupId',
      sorter: (a, b) =>
        a.email > b.email ? 1 : a.email === b.email ? 0 : -1,
      render: (record) => {
        if(selectedRowKeys && allGroups && selectedRowKeys.groupId){
          if(selectedRowKeys.matchingIndexesPlusOne && selectedRowKeys.matchingIndexesPlusOne.includes(record.key)){
            const group = allGroups.find(i => i.id === selectedRowKeys.groupId)
            return group && group.name
          }else{return "N/A"}

        }else{return "N/A"}
      },
    },
  ];
  const rowSelection = {
    type: 'checkbox',
    selectedRowKeys:selectedRowKeys.matchingIndexesPlusOne,
    onChange: (selectedRowKeys, selectedRows) => {
      console.log('selectedRowKeys:', selectedRowKeys);
      console.log('selectedRows:', selectedRows);
      // setSelectedRowKeys(selectedRowKeys); // Update selectedRowKeys using functional update
      setSelectedRowKeys((prev)=> ({...prev, matchingIndexesPlusOne:selectedRowKeys}));
    },
    // getCheckboxProps: (record) => ({
    //   checked: selectedRowKeys.includes(String(record.key)), // Check if the record id is included in selectedRowKeys (convert id to string if necessary)
    // }),
  };
  const filteredContacts = clientContacts && clientContacts.filter((contact) =>
  contact.name && contact.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredGroupContacts = clientContacts && clientContacts.filter((contact) =>
    contact.name && contact.name.toLowerCase().includes(searchGroupContacts.toLowerCase())
  );
  const handleClose= async()=>{
  setAddGroup(false);
  setEditGroup(false);
  setEditContacts(false);
  setViewContacts(false);
  setImportContacts(false);
  setAddContact(false);
  await getContacts();
  await getGroups();

  }
  const handleCloseAddContact=()=>{
    setAddGroup(false);
    setEditGroup(false);
    setEditContacts(false);
    setViewContacts(false);
    setImportContacts(false);
    setAddContact(false);
    getContacts();
  
    }
  const handleCloseConnect = () => {
    setImportContacts(false);
    getContacts();
  };
 
  const deleteGroup = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Group?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteGroup(id);
          setLoading(false);
          getGroups();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Group has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Group is safe :)", "error");
      }
    });
  };

  const saveGroupChanges = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Changes have not been saved. Are you sure you want to leave?",
      dangerMode: true,
      buttons: ["Leave", "Cancel"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        // try {
        //   setLoading(true);
        //   await DEATH_API.deleteGroup(id);
        //   setLoading(false);
        //   getGroups();
        // } catch (error) {
        //   console.log(error);
        //   setLoading(false);
        // }
        // setTimeout(async () => {
        //   swal("Deleted!", "Your Group has been deleted.", "success");
        // }, 0);
      } else {
        swal("Cancelled", "Your Changes are safe :)", "error");
      }
    });
  };
  
  const deleteCloudContact = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Contact?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteCloudContact(id);
          setLoading(false);
          await getContacts();
          await getGroups();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          swal("Deleted!", "Your Contact has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your Contact is safe :)", "error");
      }
    });
  };
  const getGroups = async () => {
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.getGroups();
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.groups) {
        setAllGroups(apiResponse.groups);
        
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getGroupContacts = async (id) => {
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.getGroupContacts(id);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.contacts) {
        // Extracting only the cloud_contact objects from the contacts array
        const cloudContacts = apiResponse.contacts.map(contact => contact.cloud_contact).filter(Boolean);
        console.log("Cloud Contacts:", cloudContacts,clientContacts);
        // const matchingRows = clientContacts && clientContacts.filter((item) => {
        //   return cloudContacts.some((apiItem) => apiItem.phoneNumber === item.phoneNumber);
        // });
        const matchingIndexes = cloudContacts.map(apiItem => {
          const index = clientContacts.findIndex(item => item.phoneNumber === apiItem.phoneNumber);
          return index !== -1 ? index : null; // Return null if not found
        }).filter(index => index !== null);
      
        console.log("matchingIndexes:", matchingIndexes);
        const matchingIndexesPlusOne = matchingIndexes.map(index => index + 1);
        // const matchingIds = matchingRows.map((row) => (row.id));
        // console.log("matchingKeys", matchingIds);
        setSelectedRowKeys({matchingIndexesPlusOne:matchingIndexesPlusOne,groupId:id});
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  
  const getContacts = async () => {
    try {
      setLoading(true);
      setClientContacts([])
      let apiResponse = await DEATH_API.getClientContacts();
      console.log("apiResponse 22", apiResponse);
      if (apiResponse && apiResponse.data) {
        const apiData = apiResponse.data.map((item, index) => {
          let fullName = null;
      
          if (item.name && item.name.trim() !== "") {
            fullName = item.name.trim();
          } else {
            if (item.firstName && item.firstName.trim() !== "" && item.lastName && item.lastName.trim() !== "") {
              fullName = item.firstName.trim() + " " + item.lastName.trim();
            }
          }
      
          // Add key with index + 1 value
          const newItem = { ...item, name: fullName, };
          return newItem;
        });
        const filteredApiData = apiData.filter((item) => item.name !== null && item.name !== '');
        const filteredApiDataWithKeys = filteredApiData.map((item, index) => ({
          ...item,
          key: index + 1
          }));
        setClientContacts(filteredApiDataWithKeys);
        console.log("apidata22", filteredApiDataWithKeys,filteredApiData)
      }
      // if (apiResponse && apiResponse.data) {
      //   const apiData = apiResponse.data.map((item, index) => {
      //     let fullName = "";
      //     if (item.firstName && item.firstName.trim() !== "") {
      //       fullName += item.firstName.trim();
      //     }
      //     if (item.lastName && item.lastName.trim() !== "") {
      //       fullName += " " + item.lastName.trim();
      //     }
      //     // If fullName is still empty, set it to null
      //     fullName = fullName.trim() !== "" ? fullName.trim() : null;
      
      //     // Concatenate firstName and lastName if name is null or empty
      //     if (!item.name || item.name.trim() === '') {
      //       return { ...item, name: fullName };
      //     } else {
      //       return item;
      //     }
      //   });
      //   const filteredApiData = apiData.filter((item) => item.name !== null && item.name !== '');
      //   setClientContacts(filteredApiData);
      // }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  
  // const getContacts = async () => {
  //   try {
  //     setLoading(true);
  //     let data = await DEATH_API.getClientContacts();
  //     console.log("datares",data);
  //     if(data && data.data){

  //       setClientContacts(data.data)
  //       const matchingRows = data.data.filter((item) => {
  //         return data.some((apiItem) => apiItem.phoneNumber === item.phoneNumber);
  //       });
  //       setSelectedRowKeys(matchingRows);
  //     console.log("matchingKeys",matchingRows)
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    // Check if the URL contains the authorization code
    getContacts();
    getGroups();
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code) {
      handleAppleResponse({ authorization: code });
    }
  }, []);

  const handleAppleResponse = async (response) => {
    console.log("response", response);
    try {
      setLoading(true);
      // Extract the authorization code from the response
      const { authorization } = response;
      // Make a request to your server to exchange the authorization code for tokens
      const tokenResponse = await axios.post("/apple/token", { authorization });
      // Extract the access token from the response
      const { access_token } = tokenResponse.data;
      // Make a request to fetch contacts using the access token
      const contactsResponse = await axios.get(`/apple/contacts`, {
        headers: { Authorization: `Bearer ${access_token}` },
      });
      // Handle the response containing contacts
      console.log("Contacts:", contactsResponse.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setLoading(false);
    }
  };



  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", padding:"1rem" }}>
        <div className="chatMain">
        <ModalVideo module="Client Contacts" autoOpen={true} />
          {/*<div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginBottom: "1rem",
            }}
          >
            <img
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "80%",
              }}
              src={logo}
              className=""
            />
            </div> */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 className="contactsSubHeading">Contacts</h3>
            <div className="addButtonContainer">
              <div className="addButtonContact"  onClick={()=>{
                if(groupNameEdit && groupNameEdit!==""){
                  swal({
                    title: "Are you sure?",
                    text: "Changes have not been saved. Are you sure you want to leave?",
                    dangerMode: true,
                    buttons: ["Leave", "Cancel"],
                    icon: "warning",
                    type: "warning",
                    closeOnConfirm: false,
                    closeOnCancel: false,
                  }).then(function (isConfirm) {
                    // Redirect the user
                    if (isConfirm) {
                      setAddContact(true);
                      setAddGroup(false);
                      setEditContacts(false);
                      setViewContacts(false);
                      setImportContacts(false);
                      setEditGroup(false);
                      setGroupNameEdit("");
                    } else {
                      swal("Cancelled", "Your Changes are safe :)", "error");
                    }
                  });
                }else{
                  setAddContact(true);
                  setAddGroup(false);
                  setEditContacts(false);
                  setViewContacts(false);
                  setImportContacts(false);
                  setEditGroup(false);
                }

              }}>+</div>
              <div>
                <img style={{ cursor: "pointer" }} src={tag} alt="tag" onClick={()=>{
                  if(groupNameEdit && groupNameEdit!==""){
                    swal({
                      title: "Are you sure?",
                      text: "Changes have not been saved. Are you sure you want to leave?",
                      dangerMode: true,
                      buttons: ["Leave", "Cancel"],
                      icon: "warning",
                      type: "warning",
                      closeOnConfirm: false,
                      closeOnCancel: false,
                    }).then(function (isConfirm) {
                      // Redirect the user
                      if (isConfirm) {
                        setAddGroup(true);
                        setEditGroup(false);
                        setGroupName('');
                        setViewContacts(false);
                        setEditContacts(false);
                        setImportContacts(false); 
                        setAddContact(false);
                        getGroups();
                        setGroupNameEdit("");
                      } else {
                        swal("Cancelled", "Your Changes are safe :)", "error");
                      }
                    });
                  }else{
                    setAddGroup(true);
                    setEditGroup(false);
                    setGroupName('');
                    setViewContacts(false);
                    setEditContacts(false);
                    setImportContacts(false); 
                    setAddContact(false);
                    getGroups();
                  }

                  }}></img>
              </div>
              <div>
                {" "}
                <img
                  style={{ cursor: "pointer" }}
                  src={menuIcon}
                  alt="menuIcon"
                  height={20}
                  width={5}
                  onClick={() => {
                    //   console.log("recode", record.id);
                    //   getSelectedRow(record.id);
                    setDropdown(!dropdown);
                  }}
                ></img>
                {dropdown && (
                  <React.Fragment>
                    <div
                      onClick={() => {
                        setDropdown(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}
                    ></div>

                    <div
                      class="dropdownChat"
                      style={{ zIndex: "9999", left: "2", right: "" }}
                    >
                      <ul className="dropdownul">
                        <li
                          className="liHover"
                          style={{cursor: "not-allowed",opacity: "0.5", 
                            pointerEvents: "none",}}
                          onClick={() => {
                            //   deleteSelectedRow(record.id);
                            setDropdown(false);
                          }}
                        >
                          Sort By
                        </li>
                        <li
                        className="liHover"
                        style={{cursor:clientContacts && clientContacts.length>0 ? "pointer" :"not-allowed",opacity:clientContacts && clientContacts.length>0 ? "1" :"0.5", 
                            pointerEvents:
                            clientContacts && clientContacts.length>0 ? "" : "none",}}
                        onClick={() => {
                          sortBy('firstName')
                          setDropdown(false);
                        }}
                      >
                        Sort By First Name
                      </li>
                      <li
                      className="liHover"
                      style={{cursor:clientContacts && clientContacts.length>0 ? "pointer" :"not-allowed",opacity:clientContacts && clientContacts.length>0 ? "1" :"0.5", 
                            pointerEvents:
                            clientContacts && clientContacts.length>0 ? "" : "none",}}
                      onClick={() => {
                        sortBy('lastName')
                        setDropdown(false);
                      }}
                    >
                      Sort By Last Name
                    </li>
                        <li
                          className="liHover"
                          onClick={() => {
                            console.log("here in import")
                            if(groupNameEdit && groupNameEdit!==""){
                              swal({
                                title: "Are you sure?",
                                text: "Changes have not been saved. Are you sure you want to leave?",
                                dangerMode: true,
                                buttons: ["Leave", "Cancel"],
                                icon: "warning",
                                type: "warning",
                                closeOnConfirm: false,
                                closeOnCancel: false,
                              }).then(function (isConfirm) {
                                // Redirect the user
                                if (isConfirm) {
                                  setAddContact(false)
                                  setDropdown(false);
                                  setImportContacts(true);
                                  setViewContacts(false);
                                  setEditContacts(false);
                                  setAddGroup(false);
                                  setEditGroup(false);
                                  setGroupNameEdit("");
                                } else {
                                  swal("Cancelled", "Your Changes are safe :)", "error");
                                }
                              });
                            }else{
                              setAddContact(false)
                              setDropdown(false);
                              setImportContacts(true);
                              setViewContacts(false);
                              setEditContacts(false);
                              setAddGroup(false);
                              setEditGroup(false);
                            }
                          }}
                        >
                          Import Contacts
                        </li>
                        <li
                          className="liHover"
                          style={{cursor:clientContacts && clientContacts.length>0 ? "pointer" :"not-allowed",opacity:clientContacts && clientContacts.length>0 ? "1" :"0.5", 
                            pointerEvents:
                            clientContacts && clientContacts.length>0 ? "" : "none",}}
                          onClick={() => {
                            setDropdown(false);
                            downloadCSV();
                            // exportCloudContacts();
                            // setImportContacts(true);
                          }}
                        >
                          Export Contacts
                        </li>
                      </ul>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            <input
              className="searchStyle"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
          {filteredContacts && filteredContacts.length>0 &&
          <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
              style={{ display: "none" }}
            />
            <span
              style={{
                display: "inline-block",
                width: "16px",
                height: "16px",
                marginRight: "8px",
                border: "1px solid #2A3DA3",
                backgroundColor: selectAll ? "#2A3DA3" : "#FFF",
                borderRadius: "3px",
                textAlign: "center",
                lineHeight: "16px",
                fontSize: "14px",
                color: "white"
              }}
            >
              {selectAll ? "✔" : ""}
            </span>
            Select All
          </label>
            }
          {selectedCheckContacts && selectedCheckContacts.length>0 &&
          <div>  
          <img
          style={{ marginBottom: "5px", cursor: "pointer" }}
          onClick={() => {
            openModal();
          }}
          src={setting}
          height={25}
          width={25}>
          </img>
          </div>
          }
          </div>
          <div className="contactsCol" style={{position:"relative"}}>
            {filteredContacts && filteredContacts.length>0 ?
              filteredContacts.map((item, index) => (
                <div
                  key={index}
                  className="chatCardInner"
                  // style={{position:"relative"}}
                  onMouseEnter={() => setSelectedContact(item.id)}
                  onMouseLeave={() => setSelectedContact(null)}
                >
                  {" "}
                  <div className="chatCard" style={{flexWrap:"nowrap"}} 
                  onClick={() => {
                    if(groupNameEdit && groupNameEdit!==""){
                      swal({
                        title: "Are you sure?",
                        text: "Changes have not been saved. Are you sure you want to leave?",
                        dangerMode: true,
                        buttons: ["Leave", "Cancel"],
                        icon: "warning",
                        type: "warning",
                        closeOnConfirm: false,
                        closeOnCancel: false,
                      }).then(function (isConfirm) {
                        // Redirect the user
                        if (isConfirm) {
                          setViewContacts(true);
                          setEditContacts(false)
                          setContactDropdown(false);
                          setImportContacts(false);
                          setManageContact(item);
                          setAddGroup(false);
                          setEditGroup(false);
                          setAddContact(false);
                          setGroupNameEdit("");
                        } else {
                          swal("Cancelled", "Your Changes are safe :)", "error");
                        }
                      });
                    }else{
                      setViewContacts(true);
                      setEditContacts(false)
                      setContactDropdown(false);
                      setImportContacts(false);
                      setManageContact(item);
                      setAddGroup(false);
                      setEditGroup(false);
                      setAddContact(false);
                    }
                    
                  }}>
                    {item.image ? (
                      <div style={{ borderRadius: "50%" }}>
                        <img
                          src={item.image}
                          height={"48px"}
                          width={"48px"}
                          alt={"new"}
                          style={{ borderRadius: "1rem" }}
                        />
                      </div>
                    ) : (
                      <div className="contactLogo">
                        {/* item.name.charAt(0).toUpperCase() */}
                        {item.name
                          ? item.name
                              .split(" ")
                              .map((part) => part[0])
                              .join("")
                          : "N/A"}
                      </div>
                    )}{" "}
                    <div className="chatCardDesc">
                      <span className="chatName">
                        {item.name}
                      </span>
                      <span className="chatValue" style={{}}>
                        {item.phoneNumber}
                      </span>
                    </div>
                  </div>
                 {selectedContact === item.id &&
                  <Dropdown overlay={
                    <Menu>
                      <Menu.Item>
                        <div  onClick={() => {
                          //   deleteSelectedRow(record.id);
                          if(groupNameEdit && groupNameEdit!==""){
                            swal({
                              title: "Are you sure?",
                              text: "Changes have not been saved. Are you sure you want to leave?",
                              dangerMode: true,
                              buttons: ["Leave", "Cancel"],
                              icon: "warning",
                              type: "warning",
                              closeOnConfirm: false,
                              closeOnCancel: false,
                            }).then(function (isConfirm) {
                              // Redirect the user
                              if (isConfirm) {
                                setViewContacts(true);
                                setEditContacts(false)
                                setContactDropdown(false);
                                setImportContacts(false);
                                setManageContact(item);
                                setAddGroup(false);
                                setEditGroup(false);
                                setAddContact(false);
                                setGroupNameEdit("");
                              } else {
                                swal("Cancelled", "Your Changes are safe :)", "error");
                              }
                            });
                          }else{
                            setViewContacts(true);
                            setEditContacts(false)
                            setContactDropdown(false);
                            setImportContacts(false);
                            setManageContact(item);
                            setAddGroup(false);
                            setEditGroup(false);
                            setAddContact(false);
                          }
                          
                        }}>
                          Edit
                        </div>
                      </Menu.Item>
                      <Menu.Item>
                        <div   onClick={() => {
                          //   deleteSelectedRow(record.id);
                          deleteCloudContact(item.id)
                          setDropdown(false);
                          setEditContacts(false);
                          setAddContact(false);
                          setViewContacts(false);
                        }}>
                          Delete
                        </div>
                      </Menu.Item>
                     
                    </Menu>
                  }
                  // visible={contactdropdown} // Manage visibility with state
                  // trigger={['click']}
                  
                  >
                  
                  <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                  <img
                  src={menuIcon}
                  alt="time"
                  height={20}
                  width={5}
                  style={{marginRight:"1rem"}}
                  onClick={() => {
                    setContactDropdown(!contactdropdown);
                  }}
                />
                  </a>
                </Dropdown>
                 }
                 { /*<input
                  type="checkbox"
                  checked={selectedContacts.includes(item.id)}
                  onChange={() => handleCheckboxChange(item.id)}
                        /> */}
                        <label style={{ display: "flex", alignItems:"center", cursor: "pointer", marginBottom:"0px" }}>
                        <input
                          type="checkbox"
                          style={{ display: "none" }}
                          checked={selectedCheckContacts.includes(item.id)}
                          onChange={() => handleCheckboxChange(item.id)}
                        />
                        <span
                          style={{
                            display: "inline-block",
                            width: "16px",
                            height: "16px",
                            marginRight: "12px",
                            border: "1px solid #2A3DA3",
                            backgroundColor: selectedCheckContacts.includes(item.id) ? "#2A3DA3" : "#FFF", // Change background color here
                            borderRadius: "3px",
                            textAlign: "center", // Center the tick horizontally and vertically
                            lineHeight: "16px", // Align the tick vertically
                            fontSize: "14px", // Adjust the font size as needed
                            color:"white"
                          }}
                        >
                          {selectedCheckContacts.includes(item.id) ? "✔" : ""}
                        </span>
                        {item.label}
                      </label>
                </div>
              ))
              :<div className="noDataToShow" style={{textAlign:"center"}}>No Contacts To show</div>
            }
            <NewLoader isLoading={loading} />
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop:"1rem" }}>
          <div style={{display:'flex', alignItems: "baseline", justifyContent: 'center', columnGap:'3px'}}>
            <h3 className="contactsSubHeading">Groups</h3>
            <ToolTipCreator name="Contacts_Groups"/>
          </div>
            <div className="addButtonContact" onClick={()=>{

              if(groupNameEdit && groupNameEdit!==""){
                swal({
                  title: "Are you sure?",
                  text: "Changes have not been saved. Are you sure you want to leave?",
                  dangerMode: true,
                  buttons: ["Leave", "Cancel"],
                  icon: "warning",
                  type: "warning",
                  closeOnConfirm: false,
                  closeOnCancel: false,
                }).then(function (isConfirm) {
                  // Redirect the user
                  if (isConfirm) {
                    setAddGroup(true);
                    setEditGroup(false);
                    setGroupName('');
                    setViewContacts(false); 
                    setEditContacts(false);
                    setImportContacts(false);
                    setAddContact(false);
                    getGroups();
                    setGroupNameEdit("");
                  } else {
                    swal("Cancelled", "Your Changes are safe :)", "error");
                  }
                });
              }else{
                setAddGroup(true);
                setEditGroup(false);
                setGroupName('');
                setViewContacts(false); 
                setEditContacts(false);
                setImportContacts(false);
                setAddContact(false);
                getGroups();
              }
            }}>+</div>
          </div>
          <div className="groupsCol" style={{position:"relative"}}>
            {allGroups && allGroups.length>0 ?
              allGroups.map((item, index) => (
                <div key={index} className="chatCardInner" >
                  {" "}
                  <div className="chatCard" style={{flexWrap:"nowrap"}} onClick={()=>{
                    if(groupNameEdit && groupNameEdit!==""){
                      swal({
                        title: "Are you sure?",
                        text: "Changes have not been saved. Are you sure you want to leave?",
                        dangerMode: true,
                        buttons: ["Leave", "Cancel"],
                        icon: "warning",
                        type: "warning",
                        closeOnConfirm: false,
                        closeOnCancel: false,
                      }).then(function (isConfirm) {
                        // Redirect the user
                        if (isConfirm) {
                          setEditGroup(true);
                          setAddGroup(false);
                          setAddContact(false);
                          setImportContacts(false);
                          setViewContacts(false);
                          setEditContacts(false);
                          setGroupName(item.name);
                          setSelectedGroupIndex(item.id);
                          getGroupContacts(item.id)
                          setGroupNameEdit("");
                        } else {
                          swal("Cancelled", "Your Changes are safe :)", "error");
                        }
                      });
                    }else{
                      setEditGroup(true);
                      setAddGroup(false);
                      setAddContact(false);
                      setImportContacts(false);
                      setViewContacts(false);
                      setEditContacts(false);
                      setGroupName(item.name);
                      setSelectedGroupIndex(item.id);
                      getGroupContacts(item.id)
                    }

                  }}>
                    {item.image ? (
                      <div style={{ borderRadius: "50%" }}>
                        <img
                          src={item.image}
                          height={"48px"}
                          width={"48px"}
                          alt={"new"}
                          style={{ borderRadius: "1rem" }}
                        />
                      </div>
                    ) : (
                      <div className="contactLogo">
                        {/* item.name.charAt(0).toUpperCase() */}
                        {item.name
                          ? item.name
                              .split(" ")
                              .map((part) => part[0])
                              .join("")
                          : "N/A"}
                      </div>
                    )}{" "}
                    <div className="chatCardDesc">
                      <span className="chatName">
                        {item.name}
                      </span>
                      <span className="chatValue" style={{}}>
                        {item.count} Participant
                      </span>
                    </div>
                  </div>
                  <div className="contactsDelete">
                     <Dropdown trigger={["click"]} overlay={
                      <Menu>
                        <Menu.Item>
                          <div onClick={()=>{
                            if(groupNameEdit && groupNameEdit!==""){
                              swal({
                                title: "Are you sure?",
                                text: "Changes have not been saved. Are you sure you want to leave?",
                                dangerMode: true,
                                buttons: ["Leave", "Cancel"],
                                icon: "warning",
                                type: "warning",
                                closeOnConfirm: false,
                                closeOnCancel: false,
                              }).then(function (isConfirm) {
                                // Redirect the user
                                if (isConfirm) {
                                  setEditGroup(true);
                                  setAddGroup(false);
                                  setAddContact(false);
                                  setImportContacts(false);
                                  setViewContacts(false);
                                  setEditContacts(false);
                                  setGroupName(item.name);
                                  setSelectedGroupIndex(item.id);
                                  getGroupContacts(item.id)
                                  setGroupNameEdit("");
                                } else {
                                  swal("Cancelled", "Your Changes are safe :)", "error");
                                }
                              });
                            }else{
                              setEditGroup(true);
                              setAddGroup(false);
                              setAddContact(false);
                              setImportContacts(false);
                              setViewContacts(false);
                              setEditContacts(false);
                              setGroupName(item.name);
                              setSelectedGroupIndex(item.id);
                              getGroupContacts(item.id)
                            }

                          }}>
                            Edit
                          </div>
                        </Menu.Item>
                        <Menu.Item>
                          <div   onClick={() => {
                            deleteGroup(item.id)
                            setEditGroup(false);
                          }}>
                            Delete
                          </div>
                        </Menu.Item>
                       
                      </Menu>
                    }                 
                    >
                    
                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    <img
                    src={menuIcon}
                    alt="time"
                    height={18}
                    width={5}
                    style={{marginRight:"1rem"}}
                    onClick={() => {
                      // setContactDropdown(!contactdropdown);
                    }}
                  />
                    </a>
                  </Dropdown>
                {/*  <img src={closeimg} height={"15px"} alt={"new"} />
                */}{" "}
                  </div>
                </div>
              ))
              :
              <div className="noDataToShow" style={{textAlign:"center"}}>No Group To show</div>
            }
            <NewLoader isLoading={loading} />
          </div>
        </div>
        <div style={{ width: "70%" }}>
          <div style={{ padding: "1rem" }}>
          {addGroup &&
            <div  style={{
              background: "white",
              padding: "1rem",
              marginTop: "1rem",
            }}>
            <div className="infocardrowData">
            <span
              className="infocardTitle1"
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {" "}
              Groups{" "}
            </span>
            <span className="infocardsubTitle">
              <label
                className="labelStyleCheckout"
                style={{
                  display: "inline-grid",
                  width: "100%",
                  marginTop: "4px",
                }}
              >
                <h3
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    fontFamily: "Poppins",
                    lineHeight: "20px",
                    fontWeight: "700",
                  }}
                >
                  {" "}
                  Add New Group{" "}
                </h3>
                <div
                  className="inputStyleCheckoutPromo"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <input
                    name="groupName"
                    placeholder="Enter Group"
                    className="inputStylepromo"
                    style={{ width: "100%" }}
                    value={groupName && groupName}
                    onChange={(e)=>{
                    console.log("value", e.target.value)
                    setGroupName(e.target.value);
                    }}
                  />
                  <button
                    className="savebutton"
                    onClick={()=>{
                      createGroup();
                    }}
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      fontWeight: "600",
                      padding: "10px 10px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      opacity:groupName && groupName ? "1" :"0.5", 
                      pointerEvents:groupName && groupName ? "" : "none",
                    }}
                    type="submit"
                  >
                    Add
                  </button>
                </div>
                
              </label>
            </span>
          </div>
          <h3
          style={{
            marginBottom: "10px",
            fontSize: "14px",
            fontFamily: "Poppins",
            lineHeight: "20px",
            fontWeight: "700",
          }}
        >
          {" "}
          All Groups{" "}
        </h3>
          <Table columns={groupCols} dataSource={allGroups && allGroups} 
           pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
            defaultPageSize: 10, // Default page size
          }} />
          </div>
          }
          {editGroup &&
            <div  style={{
              background: "white",
              padding: "1rem",
              marginTop: "1rem",
            }}>
            <div className="infocardrowData">
            <span
              className="infocardTitle1"
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "14px",
              }}
            >
              {" "}
              Group{" "}
            </span>
            <span className="infocardsubTitle">
            <label
              className="labelStyleCheckout"
              style={{
                display: "inline-grid",
                width: "100%",
                marginTop: "4px",
              }}
            >
              <h3
                style={{
                  marginBottom: "10px",
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  lineHeight: "20px",
                  fontWeight: "700",
                }}
              >
                {" "}
                Edit Group{" "}
              </h3>
              <div
                className="inputStyleCheckoutPromo"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <input
                  name="name"
                  placeholder="Enter Group"
                  className="inputStylepromo"
                  style={{ width: "100%" }}
                  value={groupName && groupName}
                  onChange={(e)=>{
                    setGroupName(e.target.value);
                    setGroupNameEdit(e.target.value);
                  }}
                />
                {/*<button className="savebutton" onClick={()=>{updateGroupName()}} style={{width:"42px"}}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginLeft: "4px"}}>
                <img src={penIcon} style={{height: "20px", width: "20px", marginRight: "4px", marginBottom: "4px"}} alt="penImage"/>
                </div>
                </button> */}
                <button
                  className="savebutton"
                  onClick={()=>{updateGroupName()}}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: "600",
                    padding: "10px 10px",
                    width: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    opacity:groupNameEdit && groupNameEdit ? "1" :"0.5", 
                    pointerEvents:groupNameEdit && groupNameEdit ? "" : "none",
                  }}
                  type="submit"
                >
                  Save Changes
                </button> 
              </div>
              
            </label>
          </span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between"}}>
          <div style={{display:"flex",justifyContent:"space-between", gap:"1rem"}}>
          {/* <button
          className="savebutton"
          onClick={()=>{
            setAddEmailTemplate(true);
          }}
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            padding: "10px 10px",
            width: "150px",
            display: "flex",
            alignItems: "center",
          }}
          type="submit"
        >
          Send Emails
        </button>
        <button
          className="savebutton"
          onClick={()=>{
            setAddTextTemplate(true);
          }}
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            padding: "10px 10px",
            width: "150px",
            display: "flex",
            alignItems: "center",
          }}
          type="submit"
        >
          Send Texts
        </button> */}
        </div>
        <div style={{display:"flex", gap:"8px", justifyContent:"space-between"}}>
        <input
          className="searchStyle"
          placeholder="Search"
          value={searchGroupContacts}
          style={{width:"50%"}}
          onChange={(e) => setSearchGroupContacts(e.target.value)}
        />
          <button
          className="savebutton"
          onClick={()=>{

            addContactsToGroup();
          }}
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "600",
            padding: "10px 10px",
            width: "150px",
            display: "flex",
            alignItems: "baseline",
            columnGap:'3px'
          }}
          type="submit"
        >
        Update Group
        <ToolTipCreator name="Contacts_Update_Groups" iconWhite={true} />
        </button>
        </div>
        </div>
          <Table 
          // rowSelection={rowSelection}
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys: selectedRowKeys.matchingIndexesPlusOne,
            onChange: (selectedRowKeys, selectedRows) => {
              console.log('selectedRowKeys:', selectedRowKeys);
              console.log('selectedRows:', selectedRows);
              
              // setSelectedRowKeys(selectedRowKeys);
              setSelectedRowKeys((prev)=> ({...prev, matchingIndexesPlusOne:selectedRowKeys}));
              setSelectedRows(selectedRows);
            },
          }}
          columns={columns} dataSource={filteredGroupContacts && filteredGroupContacts}
          pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ['10', '20', '50', '100'], // Options for page size
            defaultPageSize: 10, // Default page size
          }}
           />
          </div>
          }
            {importContacts && <ConnectAccount close={handleCloseConnect} />}
            {/* View Contacts */}
            {viewContacts && (
              <ViewClientContacts editContacts={(state) => setEditContacts(state)} viewContacts={(state) => setViewContacts(state)}  contact={manageContact && manageContact} />
            )}

            {/* Update contacts */}
            {editContacts && <UpdateClinetContacts contact={manageContact && manageContact} close={handleClose} groups={allGroups} />}
           {addContact && <AddContacts close={handleCloseAddContact} groups={allGroups} /> }
          </div>
          <div></div>
        </div>
        {location.state && location.state.from && location.state.from === "/protector/disability" && 
        <button
            className="savebutton"
            style={{height:"fit-content"}}
            onClick={() => {
              dispatch(setActiveStep(1));
              history.goBack();
            }}
            
          >
            Cancel 
          </button>
        }
      </div>
      <Modal
      visible={isModalOpen}
      footer={null}
      onOk={closeModal}
      onCancel={openModal}
      closable={false}
      centered
    >
      <h3 className="modaltitle">Contacts</h3>
      <h3 className="modaltitle" >
      {selectedCheckContacts && selectedCheckContacts.length} Contacts Selected
      </h3>
      <div className="buttonsMain" style={{justifyContent:"center", flexDirection:"column"}}>
      <button
      className="savebutton"
      onClick={() => {
        downloadSelectedCSV();
        closeModal();
      }}
      
    >
      Export 
    </button>
    <button
      className="savebutton"
      onClick={() => {
        deleteSelectCloudContact();
        closeModal();
      }}
      
    >
      Delete
    </button>
        <button
          className="cancelbutton"
          onClick={() => {
            closeModal();
          }}
        >
          Cancel
        </button>
      </div>
    </Modal>
    {addEmailTemplate && (
    <Modal
          centered
          visible={addEmailTemplate}
          footer={null}
          closable={false}
          onCancel={false}
        >
          <h3> Email To Send</h3>
          <div style={{}}>
          <h3
          style={{
           color: "#4d5e80",
            marginBottom: "10px",
             fontSize: "14px",
             fontFamily: "Poppins",
             lineHeight: "20px",
             fontWeight: "700",
              }}
              >
               {" "}
               Subject{" "}
              </h3>
            <input
              id="name"
              type="text"
              placeholder="Subject"
              name="subject"
              className="inputStylepromo"
              style={{marginBottom:"1rem", width:"100%"}}
              onChange={(e) => {
                e.persist();
                console.log("eevnt value", e.target.value);
                setEmailTemplateData((prevFormData) => ({
                  ...prevFormData,
                  subject: e.target.value,
                }));
              }}
            />
            <ReactQuill
              id="template"
              placeholder="Type Email"
              name="email"
              onChange={(e) => {
                // e.persist();
                setEmailTemplateData((prevFormData) => ({
                  ...prevFormData,
                  emailBody: e,
                }));
              }}
            ></ReactQuill>
          </div>
          <div style={{display:"flex", justifyContent:"space-between", marginTop:"1rem", gap:"1rem"}}>
            <button className="cancelbutton" onClick={closeEmailTemplateModal}>
              Cancel
            </button>
            <button id="stop" className="savebutton" onClick={saveEmailTemplateModal}>
              Send
            </button>
          </div>
    </Modal>
    )}
    {addTextTemplate && (
        <Modal
          centered
          visible={addTextTemplate}
          footer={null}
          closable={false}
          onCancel={false}
        >
          <h3>Text To Send</h3>
          <div style={{}}>
          <h3
          style={{
           color: "#4d5e80",
            marginBottom: "10px",
             fontSize: "14px",
             fontFamily: "Poppins",
             lineHeight: "20px",
             fontWeight: "700",
              }}
              >
               {" "}
               Text{" "}
              </h3>
            <ReactQuill
              id="template"
              placeholder="Template"
              name="template"
              modules={{ toolbar: false }}
              onChange={(e) => {
                // e.persist();
                setTextTemplateData((prevFormData) => ({
                  ...prevFormData,
                  textBody: e,
                }));
              }}
            ></ReactQuill>
          </div>
          <div style={{display:"flex", justifyContent:"space-between", marginTop:"1rem", gap:"1rem"}}>
            <button className="cancelbutton" onClick={closeTextTemplateModal}>
              Cancel
            </button>
            <button className="savebutton" id="stop" onClick={saveTextTemplateModal}>
              Send
            </button>
          </div>
        </Modal>
    )}
    </div>
  );
};
